import { axios } from "../config";

export function getAllInstitutions(data) {
  return axios.get("api/v1/institutions/name", { params: data });
}

export function saveParentForm(payload) {
  return axios.post("/api/v1/parents/onboard", payload);
}

export function getAllLevels(data) {
  return axios.get("api/v1/levels/name", { params: data });
}

export function getSectionsByLevelId(data) {
  return axios.get("api/v1/classrooms/name", { params: data });
}

export function parentSendOtp(payload) {
  return axios.post("/api/v1/parents/otp-send", payload);
}

export function parentVerifyOtp(payload) {
  return axios.post("/api/v1/parents/verify-otp", payload);
}
